import React from 'react';
import { ContinuousReportingType } from '../ContinuousReporting';
import ContinuousReportingDeleteModal from './ContinuousReportingDeleteModal';
import ContinuousReportingUpdateModal from './ContinuousReportingUpdateModal';

interface ContinuousReportingActionCellProps {
	data: ContinuousReportingType;
	fetchData: () => void;
	isEnabledToView: boolean;
	state: 'DRAFT' | 'VALIDATED';
	isProjectWp: boolean;
}

const ContinuousReportingActionCell: React.FC<ContinuousReportingActionCellProps> = ({
	data,
	fetchData,
	isEnabledToView,
	state,
	isProjectWp,
}) => {
	return (
		<div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
			<ContinuousReportingUpdateModal
				data={data}
				fetchData={fetchData}
				isEnabledToView={isEnabledToView}
				state={state}
				isProjectWp={isProjectWp}
			/>
			{state === 'DRAFT' && isEnabledToView ? <ContinuousReportingDeleteModal data={data} fetchData={fetchData} /> : null}
		</div>
	);
};

export default ContinuousReportingActionCell;
